module.exports = __webpack_public_path__ + "static/media/escritorio.91ead908.jpg";